import { Injectable, signal, WritableSignal } from '@angular/core';
import { Session } from '../../models/session.model';
import { User } from '../../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class AlfredSessionService {
  public readonly userData: WritableSignal<User | undefined> = signal<
    User | undefined
  >(undefined);
  public readonly sessionData: WritableSignal<Session | undefined> = signal<
    Session | undefined
  >(undefined);
}
